// extracted by mini-css-extract-plugin
export default {"form":"suspendAndTermination_form__INIhx"};